module.exports = __webpack_public_path__ + "static/img/z13.b12f4f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z13.png
// module id = yXqU
// module chunks = 0